import InputField from "../../applicationUi/components/intake/InputField";
import RadioGroup from "../../applicationUi/components/intake/RadioGroup";
import TextAreaField from "../../applicationUi/components/intake/TextAreaField";

const EducationHistorySection = ({ formData, handleChange, isReadOnly = false }) => (
  <section className="space-y-8">
    <div className="space-y-2">
      <h2 className="text-xl font-semibold text-foreground">H - Education History</h2>
      <p className="text-sm text-muted-foreground">
        Educational background and academic performance.
      </p>
    </div>

    {/* Age the child started school */}
    <InputField
      label="What age did your child start school?"
      name="educationHistory.startedSchoolAge"
      value={formData.educationHistory.startedSchoolAge}
      onChange={handleChange}
          readOnly={isReadOnly}
    />

    {/* Repeated or skipped grades */}
    <RadioGroup
      label="Were any grades repeated or skipped?"
      name="educationHistory.repeatedGrades"
      options={[
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ]}
      selectedValue={formData.educationHistory.repeatedGrades}
      onChange={handleChange}
          readOnly={isReadOnly}
    />

    {formData.educationHistory.repeatedGrades === "yes" && (
      <TextAreaField
        label="Please describe the skipped or repeated grades"
        name="educationHistory.repeatedGradesDescription"
        value={formData.educationHistory.repeatedGradesDescription}
        onChange={handleChange}
          readOnly={isReadOnly}
      />
    )}

    {/* General grades */}
    <InputField
      label="What are your child's grades in general?"
      name="educationHistory.generalGrades"
      value={formData.educationHistory.generalGrades}
      onChange={handleChange}
          readOnly={isReadOnly}
    />

    {/* Satisfaction with performance */}
    <InputField
      label="Are you satisfied with your child's performance in school?"
      name="educationHistory.satisfiedWithPerformance"
      value={formData.educationHistory.satisfiedWithPerformance}
      onChange={handleChange}
          readOnly={isReadOnly}
    />

    {/* Specific subjects with difficulty */}
    <InputField
      label="Are there any school subjects with which your child has particular difficulty?"
      name="educationHistory.specificDifficultySubjects"
      value={formData.educationHistory.specificDifficultySubjects}
      onChange={handleChange}
          readOnly={isReadOnly}
    />

    {/* How the child gets along with other children */}
    <InputField
      label="How does your child get along with other school children?"
      name="educationHistory.getsAlongWithSchoolChildren"
      value={formData.educationHistory.getsAlongWithSchoolChildren}
      onChange={handleChange}
          readOnly={isReadOnly}
    />
  </section>
);

export default EducationHistorySection;
